import React from 'react'
import Svg from '../elements/Svg'

export const Eleventy = props => (
  <Svg
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    viewBox='0 0 15694 21860'
    bg='#292929'
    {...props}
  >
    <path
      fill='#fff'
      stroke='#fff'
      strokeMiterlimit={10}
      strokeWidth={280}
      d='M5622 14101c-90 0-135-120-135-361V7789c0-115-23-169-70-162l-431 108c-79 7-118-72-118-237v-517c0-143 43-224 129-242l1422-366c11-3 27-5 48-5 79 0 118 84 118 253v7120c0 241-47 361-140 361zm3683 11c-144 0-268-10-374-30s-216-65-331-135-209-166-283-288-134-293-180-512-70-479-70-781V9604c0-72-20-108-59-108h-334c-90 0-135-86-135-258v-291c0-176 45-264 135-264h334c39 0 59-48 59-145l97-2095c11-190 57-285 140-285h539c90 0 135 95 135 285v2095c0 97 21 145 65 145h687c90 0 135 88 135 264v291c0 172-45 258-135 258h-689c-25 0-42 6-51 19-9 12-13 42-13 89v2779c0 208 13 382 40 520s66 240 118 304 104 108 156 129c52 22 116 32 191 32h382c97 0 145 67 145 199v323c0 147-52 221-156 221zm2067 646c82 0 154-67 215-202s92-326 92-574c0-58-36-257-108-598l-1056-4389c-7-50-11-90-11-119 0-129 27-194 81-194h652c50 0 91 17 124 51s58 103 75 207l700 3705c14 43 23 65 27 65 14 0 22-20 22-59l549-3695c14-108 37-180 67-218s69-57 116-57h452c61 0 92 70 92 210 0 32-4 74-11 124l-959 4993c-75 413-158 729-248 948s-190 368-302 447a776 776 0 0 1-442 124h-54c-291 0-488-77-592-232-29-32-43-115-43-248 0-266 43-399 129-399 7 0 72 18 194 54 124 38 203 56 239 56zm-8460-647c-90 0-135-120-135-361V7799c0-115-23-169-70-162l-431 108c-79 7-118-72-118-237v-517c0-143 43-224 129-242l1423-367c11-3 27-5 48-5 79 0 118 84 118 253v7120c0 241-47 361-140 361z'
    />
  </Svg>
)
